module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/71e18caa5aa8dbdbf4c9964298d4a0fd.png";